import { render, staticRenderFns } from "./level-action-rewards.vue?vue&type=template&id=0b0f5fbc&"
import script from "./level-action-rewards.vue?vue&type=script&lang=js&"
export * from "./level-action-rewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports